import React from 'react';
import { Calendar, Clock, MapPin, User, Phone, Mail, ArrowRight, ShieldCheck } from 'lucide-react';
import { motion } from 'framer-motion';
import { PageTransition } from '../components/PageTransition';
export function Book() {
  return <PageTransition data-id="element-198">
      <div className="bg-gray-50 min-h-screen pb-20" data-id="element-199">
        {/* Page Header */}
        <div className="bg-brand-blue text-white py-16 lg:py-24" data-id="element-200">
          <div className="container mx-auto px-4 md:px-6 text-center" data-id="element-201">
            <motion.h1 initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} className="text-4xl md:text-5xl font-extrabold mb-4 tracking-tight" data-id="element-202">
              Book a Ride
            </motion.h1>
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.1
          }} className="text-lg md:text-xl text-blue-100 max-w-2xl mx-auto" data-id="element-203">
              Fill out the details below to request non-emergency medical
              transportation. Our dispatch team will confirm your booking
              shortly.
            </motion.p>
          </div>
        </div>

        <div className="container mx-auto px-4 md:px-6 -mt-8" data-id="element-204">
          <div className="grid lg:grid-cols-3 gap-8 items-start" data-id="element-205">
            {/* Booking Form */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.2
          }} className="lg:col-span-2 bg-white rounded-3xl shadow-xl p-6 md:p-10 border border-gray-100" data-id="element-206">
              <form className="space-y-8" data-id="element-207">
                {/* Section 1: Patient Details */}
                <div data-id="element-208">
                  <h2 className="text-2xl font-bold text-brand-blue mb-6 flex items-center gap-2" data-id="element-209">
                    <User className="text-brand-red" data-id="element-210" /> Patient Information
                  </h2>
                  <div className="grid md:grid-cols-2 gap-6" data-id="element-211">
                    <div data-id="element-212">
                      <label className="block text-sm font-bold text-gray-700 mb-2" data-id="element-213">
                        First Name
                      </label>
                      <input type="text" className="w-full p-4 rounded-xl border border-gray-200 focus:border-brand-blue focus:ring-2 focus:ring-brand-blue outline-none transition-all bg-gray-50 focus:bg-white" placeholder="John" data-id="element-214" />
                    </div>
                    <div data-id="element-215">
                      <label className="block text-sm font-bold text-gray-700 mb-2" data-id="element-216">
                        Last Name
                      </label>
                      <input type="text" className="w-full p-4 rounded-xl border border-gray-200 focus:border-brand-blue focus:ring-2 focus:ring-brand-blue outline-none transition-all bg-gray-50 focus:bg-white" placeholder="Doe" data-id="element-217" />
                    </div>
                    <div data-id="element-218">
                      <label className="block text-sm font-bold text-gray-700 mb-2" data-id="element-219">
                        Phone Number
                      </label>
                      <div className="relative" data-id="element-220">
                        <Phone className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400" size={20} data-id="element-221" />
                        <input type="tel" className="w-full p-4 pl-12 rounded-xl border border-gray-200 focus:border-brand-blue focus:ring-2 focus:ring-brand-blue outline-none transition-all bg-gray-50 focus:bg-white" placeholder="(555) 000-0000" data-id="element-222" />
                      </div>
                    </div>
                    <div data-id="element-223">
                      <label className="block text-sm font-bold text-gray-700 mb-2" data-id="element-224">
                        Email Address
                      </label>
                      <div className="relative" data-id="element-225">
                        <Mail className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400" size={20} data-id="element-226" />
                        <input type="email" className="w-full p-4 pl-12 rounded-xl border border-gray-200 focus:border-brand-blue focus:ring-2 focus:ring-brand-blue outline-none transition-all bg-gray-50 focus:bg-white" placeholder="john@example.com" data-id="element-227" />
                      </div>
                    </div>
                  </div>
                </div>

                <hr className="border-gray-100" data-id="element-228" />

                {/* Section 2: Trip Details */}
                <div data-id="element-229">
                  <h2 className="text-2xl font-bold text-brand-blue mb-6 flex items-center gap-2" data-id="element-230">
                    <MapPin className="text-brand-red" data-id="element-231" /> Trip Details
                  </h2>
                  <div className="grid md:grid-cols-2 gap-6 mb-6" data-id="element-232">
                    <div data-id="element-233">
                      <label className="block text-sm font-bold text-gray-700 mb-2" data-id="element-234">
                        Pickup Address
                      </label>
                      <input type="text" className="w-full p-4 rounded-xl border border-gray-200 focus:border-brand-blue focus:ring-2 focus:ring-brand-blue outline-none transition-all bg-gray-50 focus:bg-white" placeholder="123 Home St, City, ST" data-id="element-235" />
                    </div>
                    <div data-id="element-236">
                      <label className="block text-sm font-bold text-gray-700 mb-2" data-id="element-237">
                        Drop-off Address
                      </label>
                      <input type="text" className="w-full p-4 rounded-xl border border-gray-200 focus:border-brand-blue focus:ring-2 focus:ring-brand-blue outline-none transition-all bg-gray-50 focus:bg-white" placeholder="456 Hospital Blvd, City, ST" data-id="element-238" />
                    </div>
                    <div data-id="element-239">
                      <label className="block text-sm font-bold text-gray-700 mb-2" data-id="element-240">
                        Date
                      </label>
                      <div className="relative" data-id="element-241">
                        <Calendar className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400" size={20} data-id="element-242" />
                        <input type="date" className="w-full p-4 pl-12 rounded-xl border border-gray-200 focus:border-brand-blue focus:ring-2 focus:ring-brand-blue outline-none transition-all bg-gray-50 focus:bg-white" data-id="element-243" />
                      </div>
                    </div>
                    <div data-id="element-244">
                      <label className="block text-sm font-bold text-gray-700 mb-2" data-id="element-245">
                        Requested Time
                      </label>
                      <div className="relative" data-id="element-246">
                        <Clock className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400" size={20} data-id="element-247" />
                        <input type="time" className="w-full p-4 pl-12 rounded-xl border border-gray-200 focus:border-brand-blue focus:ring-2 focus:ring-brand-blue outline-none transition-all bg-gray-50 focus:bg-white" data-id="element-248" />
                      </div>
                    </div>
                  </div>

                  <div data-id="element-249">
                    <label className="block text-sm font-bold text-gray-700 mb-3" data-id="element-250">
                      Service Type Needed
                    </label>
                    <div className="grid sm:grid-cols-3 gap-4" data-id="element-251">
                      {['Ambulatory', 'Wheelchair', 'Stretcher'].map(type => <label key={type} className="flex items-center gap-3 p-4 border border-gray-200 rounded-xl cursor-pointer hover:bg-brand-light transition-colors has-[:checked]:border-brand-blue has-[:checked]:bg-brand-light" data-id="element-252">
                          <input type="radio" name="serviceType" value={type} className="w-4 h-4 text-brand-blue focus:ring-brand-blue" data-id="element-253" />
                          <span className="font-semibold text-gray-700" data-id="element-254">
                            {type}
                          </span>
                        </label>)}
                    </div>
                  </div>
                </div>

                <hr className="border-gray-100" data-id="element-255" />

                {/* Section 3: Additional Info */}
                <div data-id="element-256">
                  <label className="block text-sm font-bold text-gray-700 mb-2" data-id="element-257">
                    Special Requirements or Notes
                  </label>
                  <textarea rows={4} className="w-full p-4 rounded-xl border border-gray-200 focus:border-brand-blue focus:ring-2 focus:ring-brand-blue outline-none transition-all bg-gray-50 focus:bg-white resize-none" placeholder="E.g., Needs oxygen, bringing a family member, bariatric wheelchair needed..." data-id="element-258"></textarea>
                </div>

                <button type="button" className="w-full bg-brand-red text-white py-5 rounded-xl font-bold text-xl hover:opacity-90 transition-all shadow-lg shadow-red-900/20 flex items-center justify-center gap-3" data-id="element-259">
                  Submit Booking Request <ArrowRight size={24} data-id="element-260" />
                </button>
                <p className="text-center text-sm text-gray-500 font-medium" data-id="element-261">
                  By submitting, you agree to our terms of service. We will
                  contact you to confirm availability.
                </p>
              </form>
            </motion.div>

            {/* Sidebar Information */}
            <motion.div initial={{
            opacity: 0,
            x: 20
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            delay: 0.3
          }} className="space-y-6" data-id="element-262">
              <div className="bg-white rounded-3xl shadow-xl p-8 border border-gray-100" data-id="element-263">
                <h3 className="text-xl font-bold text-brand-blue mb-4" data-id="element-264">
                  Need immediate help?
                </h3>
                <p className="text-gray-600 mb-6 leading-relaxed" data-id="element-265">
                  If you need to schedule a ride within the next 24 hours,
                  please call our dispatch center directly for the fastest
                  service.
                </p>
                <a href="tel:5551234567" className="flex items-center justify-center gap-3 w-full bg-brand-light text-brand-blue py-4 rounded-xl font-bold text-lg hover:bg-blue-100 transition-colors" data-id="element-266">
                  <Phone size={20} data-id="element-267" /> (555) 123-4567
                </a>
              </div>

              <div className="bg-brand-blue text-white rounded-3xl shadow-xl p-8" data-id="element-268">
                <ShieldCheck size={40} className="text-brand-red mb-4" data-id="element-269" />
                <h3 className="text-xl font-bold mb-4" data-id="element-270">Safe & Secure</h3>
                <ul className="space-y-3 text-blue-100" data-id="element-271">
                  <li className="flex items-center gap-2" data-id="element-272">
                    <div className="w-1.5 h-1.5 rounded-full bg-brand-red" data-id="element-273" />{' '}
                    HIPAA Compliant
                  </li>
                  <li className="flex items-center gap-2" data-id="element-274">
                    <div className="w-1.5 h-1.5 rounded-full bg-brand-red" data-id="element-275" />{' '}
                    Certified Drivers
                  </li>
                  <li className="flex items-center gap-2" data-id="element-276">
                    <div className="w-1.5 h-1.5 rounded-full bg-brand-red" data-id="element-277" />{' '}
                    Sanitized Vehicles
                  </li>
                  <li className="flex items-center gap-2" data-id="element-278">
                    <div className="w-1.5 h-1.5 rounded-full bg-brand-red" data-id="element-279" />{' '}
                    Real-time Tracking
                  </li>
                </ul>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </PageTransition>;
}